import { MateHouseSessionEvent } from "@/types/entity";
import {
  AssetFileTypeEnum,
  DialogueModeEnum,
} from "../composable/dialogue/DialogueEnum";
import {
  IAsset,
  IDialogueConfig,
  ISentence,
} from "../composable/dialogue/types";
import { FrameMode } from "../enums/uiEnums";
import { IMateCharacter } from "../utils/character-utils";
import { BaseHouseScene } from "./BaseHouseScene";
import { HouseScene } from "./HouseScene";

export class HouseEventScene extends BaseHouseScene {
  currentEvent?: MateHouseSessionEvent;
  charList: IMateCharacter[] = [];
  constructor() {
    super("HouseEvent");
    this.currentEvent = this.houseSceneStore.currentEvent!;
  }

  /** @override */
  preload() {
    super.preload();
  }

  /** @override */
  create() {
    super.create();
    this.gameUIStore.frameMode = FrameMode.FULL_SCREEN;

    this.startEvent();
  }

  /** @override */
  destroy() {
    super.destroy();
    this.gameUIStore.dialogueOver();
  }

  async startEvent() {
    const dialogue = this.buildDialogueFromEvent();
    await this.gameUIStore.showDialogue({
      ...dialogue,
      mateList: this.currentEvent!.participantzz.map((item) => item.mate),
      spriteList: this.currentEvent!.participantzz.map((item) => item.sprite),
    });
    this.houseSessionStore.updateSessionEvent(this.currentEvent!.id, {
      isPlayed: true,
    });
    try {
      this.scene.remove("HouseEvent");
      this.game.scene.add("House", HouseScene, true);
    } catch {
      return;
    }
  }

  buildDialogueFromEvent(): IDialogueConfig {
    const { videoMedia: beginVideoMedia } = this.currentEvent!.event ?? {};
    const { processImagezz, videoMedia: endingVideoMedia } =
      this.currentEvent!.ending;
    const bgImages: (IAsset & { fileType: AssetFileTypeEnum.IMAGE })[] =
      processImagezz.map((item) => {
        return {
          fileType: AssetFileTypeEnum.IMAGE,
          url: item.url,
        };
      });
    const scentences: ISentence[] = this.currentEvent!.messagezz.map((item) => {
      return {
        content: item.content,
        mateId: () => item.mate,
        assets: {
          audio: item.audioMedia
            ? {
                fileType: AssetFileTypeEnum.AUDIO,
                url: item.audioMedia.url,
              }
            : undefined,
        },
      };
    });
    if (beginVideoMedia) {
      scentences.unshift({
        content: "",
        assets: {
          cg: {
            fileType: AssetFileTypeEnum.VIDEO,
            url: beginVideoMedia.url,
          },
        },
        mode: DialogueModeEnum.HIDE_DIALOGUE,
      });
    }
    if (bgImages.length > 0) {
      const sentencesPerBg = Math.ceil(scentences.length / bgImages.length);
      bgImages.forEach((bg, index) => {
        const sentenceIndex = index * sentencesPerBg;
        if (sentenceIndex < scentences.length) {
          scentences[sentenceIndex].assets = {
            ...scentences[sentenceIndex].assets,
            bg: bg,
          };
        }
      });
    }
    if (endingVideoMedia) {
      scentences.push({
        content: "",
        assets: {
          cg: {
            fileType: AssetFileTypeEnum.VIDEO,
            url: endingVideoMedia.url,
          },
        },
        mode: DialogueModeEnum.HIDE_DIALOGUE,
      });
    } else {
      scentences.push({
        charName: "事件完成",
        content: "达成结局【" + this.currentEvent!.ending.title + "】",
        assets: {
          avatar: {
            fileType: AssetFileTypeEnum.IMAGE,
            url: "",
          },
        },
      });
    }

    return {
      sentences: scentences,
      bgm: this.currentEvent!.ending.audioMedia
        ? {
            fileType: AssetFileTypeEnum.AUDIO,
            url: this.currentEvent!.ending.audioMedia.url,
          }
        : undefined,
    };
  }
}
